<template>
  <div>
    <HelloWorld msg="一诚天和" />
    <CommFooter></CommFooter>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import CommFooter from "./components/CommFooter.vue";
export default {
  name: "App",
  components: {
    HelloWorld,
    CommFooter,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url('@/assets/bg.jpg');
  background-size: cover;
}
</style>
